import { GroupType } from '../../groupType';

export function toGroupCollectionPath(groupType: GroupType) {
  return `${groupType.charAt(0).toUpperCase() + groupType.slice(1)}`;
}

export function toGroupDocumentPath(groupType: GroupType, groupId: string) {
  return `${toGroupCollectionPath(groupType)}/${groupId}`;
}
